import { Component, Input } from '@angular/core';
import { Filter } from '../../models/filter-models';
import { DisplayType } from "../../models/enums";
import { FormsModule } from '@angular/forms';
import { FilterTitleComponent } from '../../common/filter-title/filter-title.component';
import { FilterService } from '../../services/filter.service';
import { EquipmentTierPickerComponent } from '../../common/equipment-tier-picker/equipment-tier-picker.component';
import { AutocompleteComponent } from '../../common/autocomplete/autocomplete.component';
import { BaseType } from '../../models/item-data-models';
import { ItemDataService } from '../../services/item-data.service';
import { BulkImportGemsDialogComponent } from './bulk-import-gems-dialog/bulk-import-gems-dialog.component';
import { BaseComponent } from '../../common/base.component';
import { ActiveRules } from '../../services/filter-generator.service';
import { EquipmentType } from '../../models/equipment-type.enum';
import { awakenedGems, otherExceptionalGems, specialSupportGems, topTierExceptionalGems } from '../../services/generators/general-generator.service';
import { FilterCheckboxGroupComponent } from '../../common/filter-checkbox-group/filter-checkbox-group.component';

@Component({
  selector: 'app-gem-filters-poe1',
  imports: [FormsModule, FilterTitleComponent, EquipmentTierPickerComponent, AutocompleteComponent, BulkImportGemsDialogComponent, FilterCheckboxGroupComponent],
  templateUrl: './gem-filters-poe1.html',
  styleUrl: './gem-filters-poe1.scss'
})
export class GemFiltersPoe1 extends BaseComponent {
  @Input({ required: true }) filter!: Filter;
  @Input({ required: true }) activeRules!: ActiveRules;

  gemTypes: BaseType[];
  topAwakenedGems = awakenedGems.map(g => g.replace(' Support', '')).join(', ');
  topSpecialSupportGems = specialSupportGems.map(g => g.replace(' Support', '')).join(', ');
  topExceptionalSupportGems = topTierExceptionalGems.map(g => g.replace(' Support', '')).join(', ');
  otherExceptionalSupportGems = otherExceptionalGems.map(g => g.replace(' Support', '')).join(', ');

  DisplayType = DisplayType;
  EquipmentType = EquipmentType;

  bulkImportDialogOpen = false;

  constructor(private filterService: FilterService, private itemDataService: ItemDataService) {
    super();
    const itemData = this.itemDataService.getItemData();
    this.gemTypes = this.poe2 ? [] : itemData.find(i => i.itemType === 'Skill Gems')!.baseTypes.filter(b => !this.itemDataService.getTransfiguredGems().includes(b.name))
      .concat(itemData.find(i => i.itemType === 'Support Gems')!.baseTypes);
  }

  importGems(gems: BaseType[]) {
    this.filter.showSearchedGems = true;
    this.filter.showSearchedGemTypes = [...new Set([...this.filter.showSearchedGemTypes.filter(g => g !== 'None'), ...gems.map(g => g.name)])];
    if (this.filter.showSearchedGemTypes.length === 0) {
      this.filter.showSearchedGemTypes = ['None'];
    }
    this.updateFilter();
  }

  toggleHighlightTopTierAwakenedGems = () => {
    this.filter.showTopTierAwakenedGems = !this.filter.showTopTierAwakenedGems;
    this.updateFilter();
  }

  toggleHighlightTopTierSpecialSupportGems = () => {
    this.filter.showTopTierSpecialSupportGems = !this.filter.showTopTierSpecialSupportGems;
    this.updateFilter();
  }

  toggleHighlightTopTierExceptionalSupportGems = () => {
    this.filter.showTopTierExceptionalSupportGems = !this.filter.showTopTierExceptionalSupportGems;
    if (!this.filter.showTopTierExceptionalSupportGems) {
      this.filter.showOtherExceptionalSupportGems = false;
    }
    this.updateFilter();
  }

  toggleHighlightImbuedGems = () => {
    this.filter.showImbuedGems = !this.filter.showImbuedGems;
    this.updateFilter();
  }

  toggleHighlightLvl21Quality20Gems = () => {
    this.filter.showLvl21Quality20Gems = !this.filter.showLvl21Quality20Gems;
    if (!this.filter.showLvl21Quality20Gems) {
      this.filter.showLvl20Quality20Gems = false;
    }
    this.updateFilter();
  }

  toggleHighlightLvl21Gems = () => {
    this.filter.showLvl21Gems = !this.filter.showLvl21Gems;
    if (!this.filter.showLvl21Gems) {
      this.filter.showLevelGems = false;
    }
    this.updateFilter();
  }

  toggleHighlightQuality23Gems = () => {
    this.filter.showQuality23Gems = !this.filter.showQuality23Gems;
    if (!this.filter.showQuality23Gems) {
      this.filter.showQualityGems = false;
      this.filter.showOtherQualityGems = false;
    }
    this.updateFilter();
  }

  toggleHighlightSearchedGems = () => { this.filter.showSearchedGems = !this.filter.showSearchedGems; this.updateFilter(); }
  toggleHideOtherGems = () => { this.filter.hideOtherGems = !this.filter.hideOtherGems; this.updateFilter(); }

  updateFilter() {
    this.filterService.updateFilter();
  }
}
